<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    userInfo: {},
  }),
  methods: {},
}
</script>

<style>
@import './assets/css/main.css';
@import './assets/css/BX_MS06_main_style.css';

/* 全局覆盖 Element UI 遮罩层，避免打开弹框时黑/白闪烁 */
.v-modal-enter,
.v-modal-leave {
  animation: none !important;
}
.v-modal {
  transition: none !important;
  background: rgba(0, 0, 0, 0.5) !important; /* 固定为半透明黑 */
}

/* 限制el-dropdown-menu的高度和添加滚动 */
.el-popover,
.el-dropdown-menu,
.custom-table-checkbox,
.el-select-dropdown,
.el-picker-panel,
.el-autocomplete-suggestion,
.el-cascader__dropdown,
.el-time-panel,
.v-menu__content {
  max-height: 600px !important;
  overflow-y: auto;
  overflow-x: hidden;
  position: absolute;
  display: inline-block;
  max-width: 80%;
  /* overflow-y: auto; */
  /* overflow-x: hidden; */
  contain: content;
  background: var(--theme-surface-bg, #f3f6fb) !important;
  border: 1px solid rgba(var(--theme-accent-rgb, 93, 123, 218), 0.2) !important;
  color: var(--theme-text-primary, #1f2937) !important;
  box-shadow:
    0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14) !important;
  border-radius: 4px !important;
}

.custom-table-checkbox {
  max-height: 320px !important;
  padding: 10px 12px !important;
}

.el-popover__title,
.el-dropdown-menu__item,
.el-checkbox__label,
.el-radio__label,
.el-pagination__total,
.el-pagination__jump {
  color: var(--theme-text-primary, #1f2937) !important;
}

/* 美化滚动条 */
.el-popover::-webkit-scrollbar,
.el-dropdown-menu::-webkit-scrollbar,
.custom-table-checkbox::-webkit-scrollbar,
.v-menu__content::-webkit-scrollbar {
  width: 6px;
}

.el-popover::-webkit-scrollbar-thumb,
.el-dropdown-menu::-webkit-scrollbar-thumb,
.custom-table-checkbox::-webkit-scrollbar-thumb,
.v-menu__content::-webkit-scrollbar-thumb {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.45);
  border-radius: 3px;
}

.el-popover::-webkit-scrollbar-track,
.el-dropdown-menu::-webkit-scrollbar-track,
.custom-table-checkbox::-webkit-scrollbar-track,
.v-menu__content::-webkit-scrollbar-track {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.85);
}

/* 调整下拉菜单项的样式 */
.el-dropdown-menu__item {
  line-height: 32px !important;
  padding: 0 12px !important;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.12) !important;
  color: var(--theme-text-primary, #1f2937) !important;
}

.el-checkbox {
  margin-right: 0 !important;
}

.el-checkbox__label,
.el-radio__label {
  transition: color 0.2s ease;
}

.el-checkbox__inner,
.el-radio__inner {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.3) !important;
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.88) !important;
}

.el-checkbox__inner:hover,
.el-radio__inner:hover,
.el-checkbox__input.is-focus .el-checkbox__inner,
.el-radio__input.is-focus .el-radio__inner {
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-radio__input.is-checked .el-radio__inner {
  background: var(--theme-accent-color, #5d7bda) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label,
.el-checkbox__input.is-indeterminate + .el-checkbox__label,
.el-radio__input.is-checked + .el-radio__label {
  color: var(--theme-text-primary, #1f2937) !important;
  font-weight: 600;
}

.el-table .el-checkbox__inner,
.ve-table .el-checkbox__inner,
.ve-table-checkbox-wrapper .el-checkbox__inner,
.el-table-column--selection .el-checkbox__inner {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.34) !important;
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.96) !important;
}

.el-table .el-checkbox__input.is-checked .el-checkbox__inner,
.el-table .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.ve-table .el-checkbox__input.is-checked .el-checkbox__inner,
.ve-table .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.ve-table-checkbox-wrapper .el-checkbox__input.is-checked .el-checkbox__inner,
.ve-table-checkbox-wrapper .el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-table-column--selection .el-checkbox__input.is-checked .el-checkbox__inner,
.el-table-column--selection .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: var(--theme-accent-color, #5d7bda) !important;
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-checkbox__input.is-disabled .el-checkbox__inner,
.el-radio__input.is-disabled .el-radio__inner {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.55) !important;
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.16) !important;
}

.el-checkbox__input.is-disabled + .el-checkbox__label,
.el-radio__input.is-disabled + .el-radio__label,
.el-dropdown-menu__item.is-disabled {
  color: var(--theme-text-secondary, #7d7d7d) !important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.92) !important;
  color: var(--theme-text-primary, #1f2937) !important;
}

.el-pagination button,
.el-pagination .el-pager li {
  color: var(--theme-text-primary, #1f2937) !important;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.el-pagination .el-pager li.active {
  color: var(--theme-accent-color, #5d7bda) !important;
  font-weight: 600;
}

.el-pagination button:hover,
.el-pagination .el-pager li:hover {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-pagination button:disabled,
.el-pagination button:disabled:hover {
  color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.36) !important;
  background: transparent !important;
}

.el-pagination .el-select .el-input__inner,
.el-pagination__editor.el-input .el-input__inner {
  border-color: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.26) !important;
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.96) !important;
  color: var(--theme-text-primary, #1f2937) !important;
}

.el-pagination .el-select .el-input__inner:hover,
.el-pagination .el-select .el-input.is-focus .el-input__inner,
.el-pagination__editor.el-input .el-input__inner:hover,
.el-pagination__editor.el-input .el-input__inner:focus {
  border-color: var(--theme-accent-color, #5d7bda) !important;
}

.el-pagination .el-select .el-input .el-select__caret,
.el-pagination .btn-prev .el-icon,
.el-pagination .btn-next .el-icon {
  color: inherit !important;
}

.el-pagination.is-background .el-pager li.active,
.el-pagination.is-background .el-pager li:hover,
.el-pagination.is-background .btn-next:hover,
.el-pagination.is-background .btn-prev:hover {
  background: rgba(var(--theme-accent-rgb, 93, 123, 218), 0.14) !important;
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-loading-mask {
  background: rgba(var(--theme-surface-rgb, 243, 246, 251), 0.84) !important;
}

.el-loading-spinner i,
.el-loading-spinner .el-loading-text {
  color: var(--theme-accent-color, #5d7bda) !important;
}

.el-loading-spinner .el-loading-text {
  font-weight: 600;
}

.el-loading-spinner .path {
  stroke: var(--theme-accent-color, #5d7bda) !important;
}

/* 确保v-menu内容正确显示 */
.v-menu__content .v-list {
  padding: 0;
}

.v-menu__content .v-list-item {
  min-height: 32px;
}
</style>
